/**
 * Profile translations
 * User profile page UI text
 */

import { LANGUAGES } from '../config';

export const profileTranslations = {
  [LANGUAGES.EN]: {
    title: 'My Profile',
    userInformation: 'User Information',
    personalDetails: 'Personal Details',
    accountSettings: 'Account Settings',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordChanged: 'Password changed successfully',
    passwordError: 'Error changing password',
    passwordMismatch: 'Passwords do not match',
    roleUser: 'User',
    roleManager: 'Manager',
    roleAdmin: 'Administrator',
    yourRole: 'Your Role',
    yourPermissions: 'Your Permissions',
    yourManager: 'Your Manager',
    teamMembers: 'Team Members',
    noTeamMembers: 'No team members found',
    manageTeam: 'Manage Team',
    lastLogin: 'Last Login',
    joined: 'Joined',
    accountStatus: 'Account Status',
    active: 'Active',
    inactive: 'Inactive',
    suspended: 'Suspended',
    generalTab: 'General',
    securityTab: 'Security',
    teamTab: 'Team',
    permissionsTab: 'Permissions',
    activityTab: 'Activity',
    recentActivity: 'Recent Activity',
    noActivity: 'No recent activity found',
    emailNotifications: 'Email Notifications',
    enableNotifications: 'Enable email notifications',
    notificationSettings: 'Notification Settings',
    settingsSaved: 'Settings saved successfully'
  },
  [LANGUAGES.FR]: {
    title: 'Mon Profil',
    userInformation: 'Informations utilisateur',
    personalDetails: 'Détails personnels',
    accountSettings: 'Paramètres du compte',
    changePassword: 'Changer le mot de passe',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    passwordChanged: 'Mot de passe changé avec succès',
    passwordError: 'Erreur lors du changement de mot de passe',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    roleUser: 'Utilisateur',
    roleManager: 'Gestionnaire',
    roleAdmin: 'Administrateur',
    yourRole: 'Votre rôle',
    yourPermissions: 'Vos permissions',
    yourManager: 'Votre gestionnaire',
    teamMembers: 'Membres de l\'équipe',
    noTeamMembers: 'Aucun membre d\'équipe trouvé',
    manageTeam: 'Gérer l\'équipe',
    lastLogin: 'Dernière connexion',
    joined: 'Inscrit le',
    accountStatus: 'Statut du compte',
    active: 'Actif',
    inactive: 'Inactif',
    suspended: 'Suspendu',
    generalTab: 'Général',
    securityTab: 'Sécurité',
    teamTab: 'Équipe',
    permissionsTab: 'Permissions',
    activityTab: 'Activité',
    recentActivity: 'Activité récente',
    noActivity: 'Aucune activité récente trouvée',
    emailNotifications: 'Notifications par email',
    enableNotifications: 'Activer les notifications par email',
    notificationSettings: 'Paramètres de notification',
    settingsSaved: 'Paramètres enregistrés avec succès'
  }
};
